import React, {Component} from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import CheckBox from './checkbox'
import './style.css'
import axios from 'axios'
import { API_URL } from 'api'
import { access_token } from 'token'
import {Link} from 'react-router-dom'

axios.interceptors.response.use(
    config => {
        config.headers.authorization = `bearer ${access_token}`;
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

export default class Main extends Component {
    constructor(props){
        super(props);
        this.state = {
                Product : [],
            Transaksi : [],
            activeall:false,
            name: ''
        }
        
    }
    
    // componentdidmount
    async componentDidMount() {
        try{
            const response = await axios.get(`${API_URL}/api/reseller/product/cart`)
            const datas = response.data.data
            console.log(datas)
            this.setState({
                Product: [...datas]
            })
        } catch (err) {
            const errors = err.message
            console.log(errors)
        }
    }

    async postData() {
        // const newDatas = {
        //     name:this.state.name
        // }
        
        // try {
        //     const response = await axios.post(`${API_URL}/api/reseller/product/cart`,{newDatas})
        //     const datas = response.data
        //     console.log(datas)
        // } catch {

        // }

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${access_token}`);

        var formdata = new FormData();
        formdata.append("id", "1");
        formdata.append("varian_color", "");
        formdata.append("varian_weight", "");
        formdata.append("varian_size", "");
        formdata.append("varian_type", "");
        formdata.append("varian_taste", "");

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
        };

        fetch("https://supplier.malmora.com/api/reseller/product/cart", requestOptions)
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log('error', error));
    }




    // product
    handleRemove = (item) => {
        const newProduct = this.state.Product.filter(product => {return product !== item} )
        this.setState({ Product: [...newProduct] })
    }

    // chckbox all
    hadlerCheckboxall = () => {
        if(this.state.activeall === false) { 
            this.setState({activeall:true})
        }
        if(this.state.activeall === true) return this.setState({activeall:false})
    }

 
      handleMinus = (product_id) => {
           let newProduct = this.state.Product.map((item) => 
              product_id === item.id ? {...item, order_count: item.data.sub_data.order_count--} : item 
          )
          this.setState({ Product: [...newProduct] })
     }
 
      handlePlus = (product_id) => {
             let newProduct = this.state.Product.map((item) =>
               product_id === item.id ? {...item, order_count: item.data.sub_data.order_count++ } : item  
            )
            this.setState({ Product: [...newProduct] })
     }
   
   render() {

    axios.interceptors.request.use(
        config => {
            config.headers.authorization = `bearer ${access_token}`;
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

    return (
        <Container className="cart-pages">
            <h3>Keranjang Anda</h3>
            <div className="all-keranjang">
                <CheckBox onClick={()=> this.hadlerCheckboxall()} className={this.state.activeall ? "check-box-active" : null} />
                <div className="text-all-keranjang">
                    <p>Pilih Semua</p>
                    <p className="hapus-keranjang">Hapus</p>
                </div>
            </div>
            <Row>
                <Col md={7}>
                <div className="border-check-box">
                <CheckBox onClick={()=> this.hadlerCheckboxall() || this.postData()} className={this.state.active || this.state.activeall ? "check-box-active" : null} />
                <div className="text-all-keranjang">
                    <p>Cordova</p>
                </div>
            </div>
                {
                    this.state.Product.map((item, i) => {
                        return (
                                <div key={i} className="cart-product">
                                    <CheckBox onClick={()=> this.hadlerCheckboxall() || this.postData()} className={this.state.active || this.state.activeall ? "check-box-active" : null} />
                                    <div className="cart-wrap">
                                        <img src="asset/cart/kitab.png" alt="product" />
                                        <div className="text-product">
                                            <p>{item.data.sub_data.product.title}</p>
                                            <p>{item.data.sub_data.product.brand_name}</p>
                                            <p>Tersedia : {item.data.sub_data.product.stock - item.data.sub_data.order_count} Barang</p>
                                            <small>{item.data.sub_data.product.commision_rp}</small>
                                            <h5>{item.data.sub_data.product.reseller_price} <small>Harga Reseller</small></h5>
                                            <p>{item.dikirim_dari}</p>
                                        </div>
                                        <div className="plus-minus">
                                            <button type="button" className="akumulasi minus" disabled={ item.data.sub_data.order_count > 1 ? false : true} onClick={() => this.handleMinus(item.id)}>-</button>
                                            <p>{item.data.sub_data.order_count}</p>
                                            <button type="button" className="akumulasi" onClick={() => this.handlePlus(item.id)}>+</button>
                                        </div>
                                        <div className="input-delete">
                                            <input type="text" placeholder="Semangat pak kurir..." />
                                            <img src="asset/cart/delete.svg" onClick={()=>this.handleRemove(item)} alt="hapus" />
                                        </div>
                                    </div>
                            </div>
                        )
                    })
                }
                    <br />
                </Col>
                <Col md={5}>
                        {
                            this.state.Product.map((item, id) => {
                                let total = item.data.sub_data.order_count
                                let price = item.data.sub_data.product.reseller_price
                                return (
                                     <div key={id} className="carts-rincian">
                                <h3>Rincian Belanja</h3>
                                <div className="flex-transaksi">
                                    <p>Total Harga Barang</p>
                                    <p>Rp.{total * price}  </p>
                                </div>
                                <div className="flex-transaksi">
                                    <p>Potongan Diskon Barang</p>
                                    <p>-Rp.{item.data.sub_data.product.discount}</p>
                              </div>
                              <div className="flex-transaksi Total_tagihan">
                                    <p className="text-tagihan">Total Tagihan</p>
                                    <p className="text-tagihan">Rp. {total * price - item.data.sub_data.product.discount}</p>
                              </div>
                              <div className="flex-transaksi">
                              <p>Jumlah Barang</p>
                              <p>{total} Barang</p>
                                </div>
                              <Link to="/checkout"><button type="button">Beli</button></Link>
                          </div>
                                )
                            })
                        }
                  
                    <div className="warning">
                        <p>Hanya dapat membeli barang dari 1 toko</p>
                    </div>   
                </Col>
            </Row>
        </Container>
    )
 }
}
 
